export const EDGE_COLOR = "hsla(230, 10%, 35%, 0.6)";
export const EDGE_COLOR_ACTIVE = "hsla(230, 10%, 55%, 0.9)";

export const GROUP_COLORS = [
	"#6366f1",
	"#8b5cf6",
	"#ec4899",
	"#f59e0b",
	"#22c55e",
	"#06b6d4",
	"#f97316",
	"#14b8a6",
];

export const NODE_WIDTH = 240;
export const GROUP_PADDING = 30;
export const GROUP_HEADER = 36;
